import { useContext, useLayoutEffect, useState } from 'react'

import { calcApi } from 'api/calc'
import { useAppDispatch } from 'store'
import { DEMO_CALC_ID, isDemoPage } from '../../../../../utils/hooks'
import { DemoPlayerContext } from '../../player-clock'
import { hasDemoScenarioExtraServices, updateDemoExtraServices } from '../../scenario'

export const useDemoAdditionalServices = (hasScenarioServices: boolean) => {
  const isDemoMode = isDemoPage()
  const hasAvailableServices = isDemoMode
    ? hasDemoScenarioExtraServices()
    : hasScenarioServices

  return {
    accordionProps: {
      expanded: isDemoMode ? true : undefined,
    },
    findButtonProps: {
      'data-demo-allowed': isDemoMode && hasAvailableServices
        ? 'find-additional-services'
        : undefined,
      'data-demo-playback-action': isDemoMode && hasAvailableServices
        ? 'find-additional-services'
        : undefined,
    },
    skipButtonProps: {
      'data-demo-allowed': isDemoMode && !hasAvailableServices
        ? 'skip-additional-services'
        : undefined,
      'data-demo-playback-action': isDemoMode && !hasAvailableServices
        ? 'skip-additional-services'
        : undefined,
    },
  }
}

export const useDemoAdditionalServiceItem = (
  service: ExtraServiceItem,
  isChecked: boolean,
) => {
  const isScenarioService = isDemoPage() && Boolean(service.is_demo_scenario_service)

  return {
    buttonProps: {
      'data-demo-allowed': isScenarioService ? 'select-additional-service' : undefined,
      'data-demo-extra-service-id': isScenarioService ? service.id : undefined,
      'data-demo-playback-action': isScenarioService ? 'select-additional-service' : undefined,
    },
    itemProps: {
      'data-demo-extra-service-selected': isScenarioService && isChecked ? 'true' : undefined,
      'data-demo-scenario-extra-service': isScenarioService ? 'true' : undefined,
    },
  }
}

export const useDemoAdditionalModal = (hasSelectedServices: boolean) => {
  const isDemoMode = isDemoPage()

  return {
    buttonProps: {
      'data-demo-allowed': isDemoMode ? 'save-additional-services-modal' : undefined,
      'data-demo-playback-action': isDemoMode ? 'save-additional-services-modal' : undefined,
      disabled: isDemoMode && !hasSelectedServices,
    },
  }
}

export const useDemoAdditionalSave = () => {
  const isDemoMode = isDemoPage()
  const isPlayer = Boolean(useContext(DemoPlayerContext))
  const dispatch = useAppDispatch()
  const [ isComplete, setIsComplete ] = useState(false)

  useLayoutEffect(() => {
    if (!isDemoMode || !isPlayer) {
      return
    }

    updateDemoExtraServices([])
    dispatch(calcApi.util.upsertQueryData('getExtraServicesByOrderId', DEMO_CALC_ID, []))
  }, [ dispatch, isDemoMode, isPlayer ])

  return {
    complete: () => setIsComplete(true),
    isDemoMode,
    buttonProps: {
      'data-demo-allowed': isDemoMode ? 'save-additional-services' : undefined,
      'data-demo-playback-action': isDemoMode ? 'save-additional-services' : undefined,
      'data-demo-playback-complete': isDemoMode && isComplete ? 'true' : undefined,
    },
  }
}
